import { createReducer } from 'redux-act';
import * as actions from '#app/actions/active';

/** Контекст формы: откуда открыли — недвижимость или инвестиции. Типы берутся из interfaceComponents по этому контексту. */
export type ActiveTypesKind = 'property' | 'invest' | 'only' | null;

interface ActiveState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  /** Контекст: 'property' | 'invest'. Список типов модалка берёт из interfaceComponents.propertyTypes / investTypes. */
  types: ActiveTypesKind;
  financialModalVisible: boolean;
  financialId: number | null;
}

const initialState: ActiveState = {
  modalVisible: false,
  form: {},
  types: null,
  financialModalVisible: false,
  financialId: null,
};

const setActiveModalVisible = (state: ActiveState, bool: boolean): ActiveState => ({
  ...state,
  modalVisible: bool,
});

const setActiveFinancialModalVisible = (state: ActiveState, bool: boolean): ActiveState => ({
  ...state,
  financialModalVisible: bool,
});

const setActiveFinancialId = (state: ActiveState, id: number | null): ActiveState => ({
  ...state,
  financialId: id,
});

const setActiveForm = (state: ActiveState, form: Record<string, unknown>): ActiveState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const setActiveTypes = (state: ActiveState, typesKind: ActiveTypesKind): ActiveState => ({
  ...state,
  types: typesKind,
});

const closeActiveForm = (state: ActiveState): ActiveState => ({
  ...state,
  form: {},
  types: null,
  modalVisible: false,
});

export default createReducer<ActiveState>(
  {
    [actions.setActiveModalVisible as any]: setActiveModalVisible,
    [actions.setActiveForm as any]: setActiveForm,
    [actions.setActiveTypes as any]: setActiveTypes,
    [actions.setActiveFinancialModalVisible as any]: setActiveFinancialModalVisible,
    [actions.setActiveFinancialId as any]: setActiveFinancialId,
    [actions.closeActiveForm as any]: closeActiveForm,
  },
  initialState
);
